import { provideWidgetClass } from 'scrivito'

export const DXPTopNavWidget = provideWidgetClass('DXPTopNavWidget', {})
